export const getPrice = (product: any): number => {
  if (product?.fixedPrice !== undefined) {
    return product.fixedPrice
  }

  // Check price variants in priority order.
  // v2 catalog products carry only `price`; productListWithPrices items carry price2/priceEn variants.
  const values = [
    product?.price2,
    product?.price,
    product?.price2E1,
    product?.priceE1,
    product?.price2E2,
    product?.priceE2,
    product?.price2E3,
    product?.priceE3,
    product?.price2E4,
    product?.priceE4,
    product?.price2E5,
    product?.priceE5,
    product?.price2E6,
    product?.priceE6,
    product?.price2E7,
    product?.priceE7,
    product?.price2E8,
    product?.priceE8,
    product?.price2E9,
    product?.priceE9,
    product?.price2E10,
    product?.priceE10,
  ]

  for (const value of values) {
    if (typeof value === 'string' && parseFloat(value) !== 0) {
      return parseFloat(value)
    }
    if (typeof value === 'number' && value !== 0) {
      return value
    }
  }

  return 0
}
